module.exports = __webpack_public_path__ + "img/hexagon-fill.6d644534.svg";